import { DateTime } from 'luxon';
import {
  AppFooter_v2 as AppFooter,
  Button_v2 as Button,
  Container_v2 as Container,
  Typography,
  TypographyVariantsEnum,
  useEvent,
  IconGiftNew,
} from '@mindly/ui-components';
import { useTranslation } from 'react-i18next';
import { useIsKeyBoardShown } from 'src/hooks/useIsKeyboardShown';

type PromocodeFeatureProps = {
  discount: number | string;
  expiredDate: number;
  onClose: () => void;
};

const PromocodeFeature = ({ discount, expiredDate, onClose }: PromocodeFeatureProps) => {
  const { t } = useTranslation('reviews');
  const isKeyboardShown = useIsKeyBoardShown();

  const handleBooking = useEvent(() => {
    onClose?.();
  });

  return (
    <>
      <Container>
        <div className="flex flex-col h-full justify-center">
          <div className="flex flex-col justify-center items-center gap-y-3">
            <IconGiftNew />
            <Typography align="center" variant={TypographyVariantsEnum.Title24Semi}>
              {t('discount.provided.title', {
                discount: `${discount}%`,
              })}
            </Typography>
            <Typography
              align="center"
              className="!text-typography-typography-primary/50"
              variant={TypographyVariantsEnum.Text14Regular}
            >
              {expiredDate
                ? t('discount.provided.description', {
                    expiredDate: DateTime.fromSeconds(expiredDate).toFormat('dd.MM.yyyy'),
                  })
                : null}
            </Typography>
          </div>
        </div>
      </Container>
      <AppFooter transparent bottomSaveArea={!isKeyboardShown} className="!pb-4">
        <Button size="large" fullWidth onClick={handleBooking}>
          {t('discount.provided.button')}
        </Button>
      </AppFooter>
    </>
  );
};

export default PromocodeFeature;
